<template>

    <div>

        <!-- Messaggio admin per god -->
        <div v-if="isGod" class="text-center text-muted py-5 px-3">
            <div class="d-inline-flex align-items-center justify-content-center bg-warning bg-opacity-10 text-warning rounded-pill w-48px h-48px mb-3">
                <i class="ph-shield-check ph-lg"></i>
            </div>
            <div class="fw-semibold text-body">Sei admin</div>
            <div class="fs-sm">Per vedere le notifiche vai direttamente alla view delle notifiche</div>
        </div>

        <!-- Empty state per utenti normali -->
        <div v-else-if="arrayNotifiche.length == 0" class="text-center text-muted py-5 px-3">
            <div class="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 text-success rounded-pill w-48px h-48px mb-3">
                <i class="ph-check-circle ph-lg"></i>
            </div>
            <div class="fw-semibold text-body">Sei in pari!</div>
            <div class="fs-sm">Non hai nuove notifiche</div>
        </div>

        <!-- Gruppi di notifiche solo per utenti normali -->
        <template v-if="!isGod">
            <template v-for="gruppo in notificheRaggruppate" :key="gruppo.LABEL">

                <div class="bg-light fw-medium py-2 px-3">{{ gruppo.LABEL }}</div>

                <div class="p-3">
                    <div v-for="notifica in gruppo.NOTIFICHE" :key="notifica.ID_NOTIFICA" class="notifica-row d-flex align-items-start mb-3 position-relative" :class="notificaClass(notifica.ID_NOTIFICA)">

                        <a href="#" class="status-indicator-container me-3">
                            <img v-if="notifica.URL_AVATAR && notifica.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS', notifica.URL_AVATAR)" class="w-40px h-40px rounded-pill" alt="">
                            <img v-else src="../assets/images/placeholders/placeholder.jpg" class="w-40px h-40px rounded-pill" alt="">
                            <span class="status-indicator bg-success"></span>
                        </a>

                        <div class="flex-fill pe-4">
                            {{ notifica.TITOLO }}
                            <div v-if="notifica.DESCRIZIONE" class="fs-sm text-muted mt-1"><a href="#" class="fw-semibold">{{ notifica.USERNAME }}</a> {{ notifica.DESCRIZIONE }}</div>
                            <div class="fs-sm text-muted mt-1">{{ formatOrario(notifica.ORARIO) }}</div>
                        </div>

                        <button type="button" class="notifica-action btn btn-light btn-icon btn-sm border-transparent rounded-pill" title="Segna come letta" v-on:click.prevent="leggiNotifica(notifica.ID_NOTIFICA,$root.utente.ID_UTENTE)">
                            <i class="ph-check"></i>
                        </button>

                    </div>
                </div>

            </template>
        </template>

    </div>

</template>



<script>

export default {
    name:"Notifiche",

    props:{
        mostra: {
            type: Boolean,
            required: true
        },
        arrayNotifiche: {
            type: Array,
            required: true
        }
    }, 

    data() {
        return {
            filters: global.filters,
            isAnimated : new Array(),
        };
    },

    methods: {
        /*
        openSchedaNotifiche() {
            utils.get('shared/notifiche', {FK_ID_UTENTE : this.$root.utente.ID_UTENTE}, (response) => {
                if (response && response.esito == 0) {
                this.notifiche = response.data;
                }
            },false);
        },
        */

        /*
        riceviNotifica(notifica) {
            this.$forceUpdate();
            /*this.notifiche.unshift({
                ...notifica,
                ORARIO: new Date().toLocaleString()
            });
            
            //this.salvaNotificaInDb(notifica);
        },
        */

        handleNewNotification(){
            if(!this.mostra){
                global.utils.alert.info("C'è una nuova Notifica per te");
                this.$emit('getNotifiche');
            }
            else{
                this.$emit('getNotifiche');
            }
        },

        leggiNotifica(idNotifica,idUtente) {
            utils.put('shared/notifiche/leggiNotifica', {FK_ID_NOTIFICA : idNotifica, FK_ID_UTENTE : idUtente}, (response) => {
                if (response.esito == 0) {
                    this.$emit('getNotifiche');
                    this.isAnimated[idNotifica] = !this.isAnimated[idNotifica];
                } 
                else {
                    console.error('Errore nella marcatura delle Notifiche', response);
                }
            },false);
        },

        notificaClass(id){
            return this.isAnimated[id] ? 'animate__animated animate__backOutRight' : '';
        },

        parseOrario(orario){
            if(!orario){
                return null;
            }
            var m = global.moment(String(orario), ['YYYY-MM-DD HH:mm:ss', global.moment.ISO_8601, 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY'], true);
            return m.isValid() ? m : null;
        },

        formatOrario(orario){
            var m = this.parseOrario(orario);
            return m ? m.format('DD/MM/YYYY - HH:mm') : orario;
        }


    },

    computed: {
        isGod(){
            return this.$root.isGod;
        },
        notificheRaggruppate(){
            var now = global.moment();
            var gruppi = {
                OGGI: { LABEL: 'Oggi', NOTIFICHE: new Array() },
                IERI: { LABEL: 'Ieri', NOTIFICHE: new Array() },
                PRECEDENTI: { LABEL: 'Precedenti', NOTIFICHE: new Array() }
            };
            for(var i = 0 ; i < this.arrayNotifiche.length ; i++){
                var notifica = this.arrayNotifiche[i];
                var m = this.parseOrario(notifica.ORARIO);
                if(m && m.isSame(now, 'day')){
                    gruppi.OGGI.NOTIFICHE.push(notifica);
                }
                else if(m && m.isSame(now.clone().subtract(1, 'day'), 'day')){
                    gruppi.IERI.NOTIFICHE.push(notifica);
                }
                else{
                    gruppi.PRECEDENTI.NOTIFICHE.push(notifica);
                }
            }
            return [gruppi.OGGI, gruppi.IERI, gruppi.PRECEDENTI].filter(g => g.NOTIFICHE.length > 0);
        }
    },

    beforeUnmount() {
        this.$root.appoggio.socket.off('newNotification', this.handleNewNotification);
    },  

    watch: {
        /*
        mostra(val) {
            if (val) {
                this.openSchedaNotifiche(); // Recupera le notifiche
                this.$root.appoggio.socket.on('newNotification', this.openSchedaNotifiche); // Ascolta l'evento
            } else {
                this.$root.appoggio.socket.off('newNotification', this.openSchedaNotifiche); // Rimuovi il listener
            }
        }
        */

        mostra(val){
            //this.$emit('getNotifiche');
        }
    },

    created() {
        if(this.$root.appoggio.socket || this.appoggio) {
            this.$root.appoggio.socket.on('newNotification', this.handleNewNotification);
        }
    }, 

    
};

</script>

<style scoped>
.notifica-action {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
}

.notifica-row:hover .notifica-action {
    opacity: 1;
}

@media (hover: none) {
    .notifica-action {
        opacity: 1;
    }
}
</style>
